"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackType = exports.AbrHeuristicBufferState = exports.AbrType = void 0;
var AbrType;
(function (AbrType) {
    AbrType["BUILT_IN"] = "BUILT-IN";
    AbrType["BBA_0"] = "BBA-0";
    AbrType["BOLA_BASIC"] = "BOLA_BASIC";
    AbrType["SIMPLE_NETWORK"] = "SIMPLE_NETWORK";
    AbrType["LLAMA"] = "LLAMA";
    AbrType["QUETRA"] = "QUETRA";
    AbrType["STALLION"] = "STALLION";
    AbrType["ELASTIC"] = "ELASTIC";
})(AbrType || (exports.AbrType = AbrType = {}));
/**
 * ShakaAbrHeuristicBufferState:
 * Defines the possible states of the heuristic
 */
var AbrHeuristicBufferState;
(function (AbrHeuristicBufferState) {
    AbrHeuristicBufferState["PANIC"] = "PANIC";
    AbrHeuristicBufferState["REBUFFER"] = "REBUFFER";
    AbrHeuristicBufferState["STEADY"] = "STEADY";
})(AbrHeuristicBufferState || (exports.AbrHeuristicBufferState = AbrHeuristicBufferState = {}));
var TrackType;
(function (TrackType) {
    TrackType["Audio"] = "Audio";
    TrackType["Video"] = "Video";
})(TrackType || (exports.TrackType = TrackType = {}));
